import React, { useState, useEffect, useCallback } from "react";

import {
  Grid,
  Box,
  ListItemText,
  Typography,
  FormControl,
  FormControlLabel,
  Select,
  MenuItem,
  Checkbox,
  Button,
  Snackbar,
  IconButton
} from "@mui/material";
import { makeStyles } from "@material-ui/core/styles";
import { useSelector, useDispatch } from "react-redux";

import { getTrainerUsageData } from "../Services";
import {
  getRolesBySiteUuid,
  getUsersByRoleId,
} from "../../../Layouts/Users/Services";

import {
  getFormatedDate,
  addDays,
  fancyTimeHhMmSs,
  fancyTimeFormat,
} from "../../../Js/TimeAndDate";
import { joinByKeys, getClassNames } from "../../../Js/Common";

// import DropDownButton from '../../../Components/DropDown/DropDownButton';

import Placeholder from "../../../Components/UI/Placeholder";
import TopButton from "../../../Components/UI/TopButtons";
import WwDateFilterModal from '../../../Components/Modal/WwDateFilterModal';

import ContentUsageSummary from "./ContentUsageSummary";
import LibraryReport from "./LibraryReport";

import { findIndex, map } from "lodash";
import TrainerDetailReport from "./TrainerDetailReport";
import BatchWiseUsageReport from "./BatchWiseUsageReport";
import { commonSliceActions } from "../../../Store/Slices/CommonSlice";

const TrainersReport = () => {
  let iniReportTypes = [
    { id: "content_usage_summary", value: "Content Usage Summary" },
    { id: "detailed_report", value: "Detailed Report" },
    { id: "batch_wise_usage_report", value: "Batch Wise Usage Report" },
    { id: "library_report", value: "Library Report" },
  ];

  let filterByDays = [
    { value: 30, label: "1 Month" },
    { value: 90, label: "3 Month" },
    { value: 180, label: "6 Month" },
    { value: 270, label: "9 Month" },
    { value: 365, label: "1 Year" },
    { value: 'range', label: "Range Filter" },
  ];

  // Hooks
  const classes = useStyles();
  const dispatch = useDispatch();

  // States
  const [reportTypeData, setReportTypeData] = useState(iniReportTypes[0]);
  const [reportTypeDataId, setReportTypeDataId] = useState(
    iniReportTypes[0].id
  );

  const [allClasses, setAllClasses] = useState([
    { id: "all", value: "All Class" },
    { id: "self", value: "Self" },
  ]);
  const [selectedClassIds, setSelectedClassIds] = useState([]);

  const [trainers, setTrainers] = useState([]);
  const [selectedTrainerId, setSelectedTrainerId] = useState([]);

  const [trainerReportData, setTrainerReportData] = useState([]);
  const [isCheckAll, setIsCheckAll] = useState(false);
  const [selectedTrainers, setSelectedTrainers] = useState([]);

  const [selectedMonthValue, setSelectedMonthValue] = useState([]);
  const [startDate, setStartDate] = useState(null);
  const [endDate, setEndDate] = useState(null);

  const [courseDetailData, setCourseDetailData] = useState([]);
  const [taskDetailData, setTaskDetailData] = useState([]);
  const [assiDetailData, setAssiDetailData] = useState([]);
  const [evalDetailData, setEvalDetailData] = useState([]);
  const [trainerDetailData, setTrainerDetailData] = useState([]);

  const [batchWiseTrainerData, setBatchWiseTrainerData] = useState([]);
  const [batchWiseCourseData, setBatchWiseCourseData] = useState([]);

  const [initialFetchDone, setInitialFetchDone] = useState(false);
  const [libraryInDetailOn, setLibraryInDetailOn] = useState(false);

  const [isWwDateFilter, setIsWwDateFilter] = useState(false);

  const [stateSnackbar, setStateSnackbar] = useState({
    open: false,
    vertical: "bottom",
    horizontal: "center",
  });
  const { vertical, horizontal, open } = stateSnackbar;

  // Redux state
  const userInfo = useSelector((state) => state.loggedInUserInfo.userInfo);

  useEffect(() => {
    initialRender();
  }, []);

  const initialRender = useCallback(async () => {
    let trainerUuids = [];
    if (userInfo.rolesInfo.title.toLowerCase() === "trainer") {
      let newUserData = {};
      newUserData.value = joinByKeys(
        userInfo.name,
        ["firstname", "lastname"],
        " "
      );
      newUserData.id = userInfo.uid;
      trainerUuids.push(newUserData);
      setSelectedTrainers(trainerUuids);
      setTrainers(trainerUuids);
    } else {
      let resTrainer = await getTrainerRole();
      if (resTrainer) {
        let params = {
          query: {
            $select: ["uid", "name"],
            role_uid: resTrainer.uid,
            site_uuid: userInfo.site_uuid,
            status: true,
            $limit: -1,
          },
        };
        let resUsersData = await getUsersByRoleId(params);
        // console.log("resUsersData===>", resUsersData);
        if (resUsersData.data.length > 0) {
          let trainerUuids = resUsersData.data.map((userData) => {
            delete userData.rolesInfo;
            let newUserData = {};
            newUserData.value = joinByKeys(
              userData.name,
              ["firstname", "lastname"],
              " "
            );
            newUserData.id = userData.uid;
            return newUserData;
          });
          setSelectedTrainers(trainerUuids);
          setTrainers(trainerUuids);
          setIsCheckAll(true);
        }
      }
    }
    let allClassesData = await getClassNames(userInfo.site_uuid);
    let allNewClassesData = allClasses.concat(allClassesData);
    setAllClasses(allNewClassesData);
    handleOnChange(filterByDays[0]);
  }, [userInfo]);


  useEffect(() => {
    if (startDate && endDate && selectedTrainers) {
      if (selectedTrainers.length > 0) {
        handleClickGo();
      }
    } else if (startDate && endDate && selectedTrainers && selectedClassIds) {
      if (selectedTrainers.length > 0 && selectedClassIds.length > 0) {
        handleClickGo();
      }
    }
  }, [
    selectedTrainers,
    startDate,
    endDate,
    selectedClassIds,
    // trainers,
    // initialFetchDone,    
  ]);

  useEffect(() => {
    clearAllState();
    if (userInfo.rolesInfo.title.toLowerCase() == "trainer") {
      initialRender();
    }
  }, [reportTypeDataId]);

  const clearAllState = () => {
    if (reportTypeDataId == "detailed_report" || reportTypeDataId == "batch_wise_usage_report") {
      setSelectedTrainerId([]);
      setTrainerReportData([]);
      setSelectedTrainers([]);

      setTrainerDetailData([]);
      setTaskDetailData([]);
      setAssiDetailData([]);
      setCourseDetailData([]);
      setEvalDetailData([]);

    } else if (reportTypeDataId == 'content_usage_summary' || reportTypeDataId == 'library_report') {
      setTrainerDetailData([]);
      setTaskDetailData([]);
      setAssiDetailData([]);
      setEvalDetailData([]);
      setCourseDetailData([]);
      setBatchWiseTrainerData([]);
      setBatchWiseCourseData([]);
      if (userInfo.rolesInfo.title.toLowerCase() !== "trainer") {
        handleSelectAll();
      }
    }
  };

  const handleOnChange = (itemData) => {
    if (itemData.value == 'range') {
      setIsWwDateFilter(true);
    } else {
      let durationDays = Number(itemData.value) - 1;
      console.log("durationDays====>", durationDays);

      let startDate = new Date();
      startDate = addDays(startDate, -itemData.value + 1);
      let endDate = addDays(startDate, durationDays);
      // console.log(startDate,endDate);

      setStartDate(getFormatedDate(startDate, "YYYY-MM-DD"));
      setEndDate(getFormatedDate(endDate, "YYYY-MM-DD"));
    }
    setSelectedMonthValue(itemData.value);
  };

  const handleClickGo = async () => {
    if (selectedTrainers.length <= 0 && (reportTypeDataId == "detailed_report" || reportTypeDataId == "batch_wise_usage_report")) {
      setTrainerReportData([]);
      setStateSnackbar({ ...stateSnackbar, open: true });
      return false;
    } else {
      console.log("selectedTrainers", selectedTrainers);
      let trainerIds = selectedTrainers.map((value) => value.id);
      // console.log("trainerIds",trainerIds);
      if (reportTypeDataId == "content_usage_summary") {
        return await fetchTrainerReports(trainerIds);
      } else if (reportTypeDataId == "detailed_report") {
        return await fetchDetailTrainerReports(trainerIds);
      } else if (reportTypeDataId == "batch_wise_usage_report") {
        return await fetchBatchWiseTrainerReports(trainerIds);
      }
    }
  };

  //content_usage_summary
  const fetchTrainerReports = async (trainerIds) => {
    dispatch(commonSliceActions.setLoader(true));
    let params = {
      query: {
        site_uuid: userInfo.site_uuid,
        fromDate: startDate,
        toDate: endDate,
        reportType: "teacherWise",
        user_uid: trainerIds,
      },
    };
    console.log("params", params);
    let resTrainerData = await getTrainerUsageData(params);
    if (resTrainerData.data.length > 0) {
      resTrainerData.data.map((val) => {
        val.detailData.sort((a, b) => {
          return new Date(b.date) - new Date(a.date);
        });
      });
      setTrainerReportData(resTrainerData.data);
    } else {
      setTrainerReportData([]);
    }
    dispatch(commonSliceActions.setLoader(false));
    if (!initialFetchDone) {
      setInitialFetchDone(true);
    }
  };

  //detailed_report
  const fetchDetailTrainerReports = async (trainerIds) => {
    setTrainerDetailData([]);
    setCourseDetailData([]);
    setTaskDetailData([]);
    setAssiDetailData([]);
    setEvalDetailData([]);
    dispatch(commonSliceActions.setLoader(true));
    let params = {
      query: {
        site_uuid: userInfo.site_uuid,
        fromDate: startDate,
        toDate: endDate,
        reportType: "dateWiseDetailReport",
        user_uid: trainerIds,
      },
    };
    console.log("params", params);
    let resDetailData = await getTrainerUsageData(params);
    console.log("detailed_report", resDetailData);
    if (resDetailData.status == 200) {
      setTrainerDetailData(resDetailData);
      setTaskDetailData(resDetailData.data[0].taskData);
      setAssiDetailData(resDetailData.data[1].assiData);
      setEvalDetailData(resDetailData.data[2].evalData);
      setCourseDetailData(resDetailData.data[3].courseData);
    }
    dispatch(commonSliceActions.setLoader(false));
  };

  //batch_wise_usage_report
  const fetchBatchWiseTrainerReports = async (trainerIds) => {
    setBatchWiseTrainerData([]);
    setBatchWiseCourseData([]);
    // console.log("selectedClassIds", selectedClassIds);
    dispatch(commonSliceActions.setLoader(true));
    // let trainerIds = selectedTrainers.map((value) => value.id);
    if (selectedClassIds.length > 0) {
      let params = {
        query: {
          site_uuid: userInfo.site_uuid,
          fromDate: startDate,
          toDate: endDate,
          reportType: "batchWiseTrainerData",
          classId: selectedClassIds,
          user_uid: trainerIds,
        },
      };
      // console.log("params", params);
      let resBatchWiseTrainerData = await getTrainerUsageData(params);
      console.log("batchWiseTrainerData", resBatchWiseTrainerData);
      if (resBatchWiseTrainerData && resBatchWiseTrainerData.status == 200) {
        resBatchWiseTrainerData.data[0].courseData.forEach((itemTable, indexTable) => {
          if (itemTable.context && (itemTable.context.classId == null || itemTable.context.classId == undefined)) {
            itemTable.context.classId = 'self';
            itemTable.context.className = '-';
            itemTable.context.topicPath = '-';
          }
        });
        setBatchWiseTrainerData(resBatchWiseTrainerData);
        setBatchWiseCourseData(resBatchWiseTrainerData.data[0].courseData);
      }
    }
    dispatch(commonSliceActions.setLoader(false));
  };

  const handleClose = () => {
    setStateSnackbar({ ...stateSnackbar, open: false });
  };

  const getTrainerRole = async () => {
    let params = {
      query: {
        $select: ["uid", "title"],
        title: "Trainer",
        site_uuid: userInfo.site_uuid,
      },
    };
    let resRolesData = await getRolesBySiteUuid(params);
    return resRolesData.data[0];
  };

  const fetchTrainer = (uid) => {
    let findObj = trainers.find((obj) => {
      return obj.id === uid;
    });
    return findObj.value;
  };

  // Select All trainers
  const handleSelectAll = (e) => {
    setIsCheckAll(!isCheckAll);
    if (isCheckAll) {
      setSelectedTrainers([]);
    } else {
      setSelectedTrainers(trainers.map((itemData) => itemData));
    }
  };

  // Add & Remove trainer from selection
  const handleSelectMultiple = (itemData) => {
    let newArray = [...selectedTrainers];
    let fndIndx = findIndex(selectedTrainers, { id: itemData.id });
    if (fndIndx === -1) {
      newArray.push(itemData);
    } else {
      newArray.splice(fndIndx, 1);
    }
    setSelectedTrainers(newArray);
    if (newArray.length === trainers.length) {
      setIsCheckAll(true);
    } else {
      setIsCheckAll(false);
    }
  };

  // single trainer selection
  const handleSelectSingle = (e) => {
    let resSelectedTrainer = trainers.filter((itemData) => {
      return itemData.id === e.target.value;
    });
    console.log("resSelectedTrainer", resSelectedTrainer);
    setSelectedTrainers(resSelectedTrainer);
    setSelectedTrainerId(resSelectedTrainer[0].id);
    setSelectedClassIds([]);
  };

  const handleReportTypeChange = (itemData) => {
    setIsCheckAll(false);
    setSelectedTrainers([]);
    setSelectedClassIds([]);
    setReportTypeData(itemData);
    setReportTypeDataId(itemData.id);
  };

  const handleClassChange = (e, itemData) => {
    // console.log("Event====>",e.target);
    // console.log("itemData====>",itemData.id);
    let newArray = [];
    if (itemData.id == 'all') {
      if (e.target.checked === true) {
        newArray = allClasses.map(function (obj) {
          return obj;
        });
      }
      setSelectedClassIds(newArray);
    } else {
      newArray = [...selectedClassIds];
      let fndIndx = findIndex(selectedClassIds, { id: itemData.id });
      if (fndIndx === -1) {
        newArray.push(itemData);
        console.log(newArray.length,"====",allClasses.length-1);
        if (newArray.length === (allClasses.length - 1)) {
          newArray.push({ id: "all", value: "All Class" });          
        }         
      } else {
        newArray.splice(fndIndx, 1);
        let fndAllIndx = findIndex(newArray, { id: 'all' });
        if (fndAllIndx !== -1) {
          newArray.splice(fndAllIndx, 1);
        }        
      }

      setSelectedClassIds(newArray);
    }

  };

  const resetState = () => {
    if (reportTypeDataId != 'content_usage_summary') {
      setIsCheckAll(false);
      setTrainerReportData([]);
      setSelectedTrainers([]);
      setReportTypeData(iniReportTypes[0]);
      setReportTypeDataId(iniReportTypes[0].id);

      setSelectedClassIds([]);
      setTrainerDetailData([]);
      setTaskDetailData([]);
      setAssiDetailData([]);
      setCourseDetailData([]);
      setEvalDetailData([]);

      setBatchWiseTrainerData([]);
      setBatchWiseCourseData([]);
      handleOnChange(filterByDays[0]);
    }
  };

  const downloadTrainerReport = async () => {
    if (trainerReportData.length > 0) {
      let csv = "";
      csv =
        "Teacher Name,Task (HH:MM:SS),Assignment (HH:MM:SS),Course View (HH:MM:SS),Evaluation (HH:MM:SS),Total Usage (HH:MM:SS)\n";

      trainerReportData.forEach((trainerData) => {
        let name = fetchTrainer(trainerData.actor);
        let taskTime = fancyTimeHhMmSs(trainerData.taskTime);
        let assiTime = fancyTimeHhMmSs(trainerData.assiTime);
        let courseTime = fancyTimeHhMmSs(trainerData.courseTime);
        let evalTime = fancyTimeHhMmSs(trainerData.evalTime);
        let totalTime = fancyTimeHhMmSs(trainerData.totalTime);
        csv =
          csv +
          name +
          "," +
          taskTime +
          "," +
          assiTime +
          "," +
          courseTime +
          "," +
          evalTime +
          "," +
          totalTime;
        csv += "\n";
      });

      let startOfDate = getFormatedDate(startDate, "DD-MMM-YY");
      let endOfDate = getFormatedDate(endDate, "DD-MMM-YY");
      let fileName =
        "ConsolidateTeacherReport_" + startOfDate + "_to_" + endOfDate + ".csv";

      let hiddenElement = document.createElement("a");
      hiddenElement.setAttribute(
        "href",
        "data:text/csv;charset=utf-8," + encodeURIComponent(csv)
      );

      hiddenElement.setAttribute("download", fileName);
      document.body.appendChild(hiddenElement);
      hiddenElement.click();
      document.body.removeChild(hiddenElement);

      // Start download teacher's date wise report
      for (let i = 0; i < trainerReportData.length; i++) {
        let csv1 = "";
        csv1 =
          "Date,Presentation (HH:MM:SS),Task (HH:MM:SS),Assignment (HH:MM:SS),Evaluation (HH:MM:SS),Total Usage (HH:MM:SS)";
        let tmp = trainerReportData[i].detailData;
        let teacherName = fetchTrainer(trainerReportData[i].actor);
        for (let j = 0; j < tmp.length; j++) {
          csv1 += "\n";
          csv1 +=
            getFormatedDate(tmp[j].date, " DD-MMM-YY") +
            "," +
            fancyTimeHhMmSs(tmp[j].courseTime) +
            "," +
            fancyTimeHhMmSs(tmp[j].taskTime) +
            "," +
            fancyTimeHhMmSs(tmp[j].assiTime) +
            "," +
            fancyTimeHhMmSs(tmp[j].evalTime) +
            "," +
            fancyTimeHhMmSs(tmp[j].totalTime);
        }
        let hiddenElement1 = document.createElement("a");
        hiddenElement1.setAttribute(
          "href",
          "data:text/csv;charset=utf-8," + encodeURIComponent(csv1)
        );
        hiddenElement1.setAttribute(
          "download",
          teacherName +
          "_" +
          getFormatedDate(startDate, "DD-MMM-YY") +
          "_to_" +
          getFormatedDate(endDate, "DD-MMM-YY") +
          ".csv"
        );
        document.body.appendChild(hiddenElement1);
        hiddenElement1.click();
        document.body.removeChild(hiddenElement1);
      }
    }
  };

  const downloadDetailTrainerReport = async () => {
    let csv = "";
    csv = "Date,Verb,Item,Duration,Class Name,Topic";
    if (courseDetailData.length > 0) {
      let presentationDetailData = await dateWiseSortData(courseDetailData);
      for (let j = 0; j < presentationDetailData.length; j++) {
        console.log("SSSS",presentationDetailData[j]);
        console.log("11111",presentationDetailData[j].context);
        let className = presentationDetailData[j].context.className ? presentationDetailData[j].context.className : '-';
        let topicPath = presentationDetailData[j].context.topicPath ? presentationDetailData[j].context.topicPath : '-';
        csv += "\n";
        csv +=
          getFormatedDate(presentationDetailData[j].created_at, "DD-MMM-YY") +
          "," +
          'Presentation' +
          "," +
          presentationDetailData[j].title +
          "," +
          fancyTimeFormat(presentationDetailData[j].sum) + " m" +
          "," +
          className +
          "," +
          topicPath;
      }
    }
    if (taskDetailData.length > 0) {
      let dateWiseTaskDetailData = await dateWiseSortData(taskDetailData);
      csv += "\n";
      for (let j = 0; j < dateWiseTaskDetailData.length; j++) {
        csv += "\n";
        csv +=
          getFormatedDate(dateWiseTaskDetailData[j].created_at, "DD-MMM-YY") +
          "," +
          'Task' +
          "," +
          dateWiseTaskDetailData[j].title +
          "," +
          fancyTimeFormat(dateWiseTaskDetailData[j].sum) + " m" +
          "," +
          '-' +
          "," +
          '-';
      }
    }
    if (assiDetailData.length > 0) {
      let dateWiseAssiDetailData = await dateWiseSortData(assiDetailData);
      csv += "\n";
      for (let j = 0; j < dateWiseAssiDetailData.length; j++) {

        csv += "\n";
        csv +=
          getFormatedDate(dateWiseAssiDetailData[j].created_at, "DD-MMM-YY") +
          "," +
          'Assignment' +
          "," +
          dateWiseAssiDetailData[j].title +
          "," +
          fancyTimeFormat(dateWiseAssiDetailData[j].sum) + " m" +
          "," +
          '-' +
          "," +
          '-';
      }
    }
    if (evalDetailData.length > 0) {
      let dateWiseEvalDetailData = await dateWiseSortData(evalDetailData);
      csv += "\n";
      for (let j = 0; j < dateWiseEvalDetailData.length; j++) {
        csv += "\n";
        csv +=
          getFormatedDate(dateWiseEvalDetailData[j].created_at, "DD-MMM-YY") +
          "," +
          'Evaluation' +
          "," +
          dateWiseEvalDetailData[j].title +
          "," +
          fancyTimeFormat(dateWiseEvalDetailData[j].sum) + " m" +
          "," +
          '-' +
          "," +
          '-';
      }
    }

    let startOfDate = getFormatedDate(startDate, "DD-MMM-YY");
    let endOfDate = getFormatedDate(endDate, "DD-MMM-YY");
    let fileName = "DetailReport_" + startOfDate + "_to_" + endOfDate + ".csv";
    let hiddenElement = document.createElement("a");
    hiddenElement.setAttribute(
      "href",
      "data:text/csv;charset=utf-8," + encodeURIComponent(csv)
    );
    hiddenElement.setAttribute("download", fileName);
    document.body.appendChild(hiddenElement);
    hiddenElement.click();
    document.body.removeChild(hiddenElement);
  };

  const downloadBatchWiseTrainerReport = async () => {
    let csv = "";
    csv = "Date,Verb,Item,Duration,Class Name,Topic";
    if (batchWiseCourseData.length > 0) {
      let presentationBatchWiseData = await dateWiseSortData(batchWiseCourseData);
      for (let j = 0; j < presentationBatchWiseData.length; j++) {
        let className = presentationBatchWiseData[j].context.className ? presentationBatchWiseData[j].context.className : '-';
        let topicPath = presentationBatchWiseData[j].context.topicPath ? presentationBatchWiseData[j].context.topicPath : '-';
        csv += "\n";
        csv +=
          getFormatedDate(presentationBatchWiseData[j].created_at, "DD-MMM-YY") +
          "," +
          'Presentation' +
          "," +
          presentationBatchWiseData[j].title +
          "," +
          fancyTimeFormat(presentationBatchWiseData[j].sum) + " m" +
          "," +
          className +
          "," +
          topicPath;
      }
    }
    let startOfDate = getFormatedDate(startDate, "DD-MMM-YY");
    let endOfDate = getFormatedDate(endDate, "DD-MMM-YY");
    let fileName = "BatchWiseReport_" + startOfDate + "_to_" + endOfDate + ".csv";
    let hiddenElement = document.createElement("a");
    hiddenElement.setAttribute(
      "href",
      "data:text/csv;charset=utf-8," + encodeURIComponent(csv)
    );
    hiddenElement.setAttribute("download", fileName);
    document.body.appendChild(hiddenElement);
    hiddenElement.click();
    document.body.removeChild(hiddenElement);
  };

  const dateWiseSortData = async (detailData) => {
    detailData.sort(function compare(a, b) {
      let dateA = new Date(b.created_at);
      let dateB = new Date(a.created_at);
      return dateA - dateB;
    });
    return detailData;
  }

  const typeWiseDownload = async () => {
    if (reportTypeDataId == "content_usage_summary") {
      await downloadTrainerReport();
    } else if (reportTypeDataId == "detailed_report") {
      await downloadDetailTrainerReport();
    } else if (reportTypeDataId == "batch_wise_usage_report") {
      await downloadBatchWiseTrainerReport();
    }
  };

  const handleFilterReport = (childParams) => {
    setStartDate(getFormatedDate(childParams.start_date, 'YYYY-MM-DD'));
    setEndDate(getFormatedDate(childParams.end_date, 'YYYY-MM-DD'));
    setIsWwDateFilter(false);
  };

  return (
    <>
      <TopButton
        title={"Trainers Usage Report"}
        secondaryText={
          getFormatedDate(startDate, "DD MMM YYYY") +
          " - " +
          getFormatedDate(endDate, "DD MMM YYYY")
        }
        downloadIcon={(selectedTrainers.length > 0 && reportTypeDataId != 'library_report') ? true : false}
        pressTopBtn={(selectedTrainers.length > 0 && reportTypeDataId != 'library_report') ? typeWiseDownload : false}
      ></TopButton>
      <Box sx={{ width: "100%" }}>
        <Grid>
          <Grid
            container
            sx={{
              flexDirection: "row",
              justifyContent: "space-around",
              alignItems: "center",
            }}
          >
            <Grid item xs={10}>
              <Grid
                container
                sx={{
                  flexDirection: "row",
                  justifyContent: "flex-start",
                  alignItems: "center",
                }}
              >
                <Grid item sx={{ px: 1 }}>
                  <FormControl
                    sx={{ m: 2, width: 150, minWidth: 150 }}
                    size="small"
                  >
                    <Typography
                      sx={{ px: 1, fontSize: '0.8rem', fontWeight: '500', color: '#DB8829', '@media (min-width: 1636px)': { fontSize: '1.4rem' } }}>
                      Report Type
                    </Typography>
                    <Select
                      value={reportTypeDataId}
                      sx={{
                        borderRadius: 20,
                        borderColor: "#DB8829",
                        color: "#DB8829",
                        fontWeight: "500",
                        "@media (min-width: 1636px)": {
                          fontSize: "1.4rem",
                          width: "20ch",
                          mt: 0.5,
                        },
                      }}
                    >
                      {iniReportTypes.map((itemData, index) => {
                        return (
                          <MenuItem
                            sx={{
                              color: "#DB8829",
                              fontSize: "0.8rem",
                              fontWeight: "500",
                              "@media (min-width: 1636px)": {
                                fontSize: "1.2rem",
                              },
                            }}
                            key={`type_${index}`}
                            value={itemData.id}
                            onClick={() => {
                              handleReportTypeChange(itemData);
                            }}
                          >
                            {itemData.value}
                          </MenuItem>
                        );
                      })}
                    </Select>
                  </FormControl>
                </Grid>
                <>
                  {trainers &&
                    userInfo &&
                    userInfo.rolesInfo.title.toLowerCase() !== "trainer" && reportTypeDataId &&
                    (reportTypeDataId == "content_usage_summary" ||
                      reportTypeDataId == "library_report") &&
                    !libraryInDetailOn && (
                      <Grid item sx={{ px: 1 }}>
                        <FormControlLabel
                          control={
                            <Checkbox
                              checked={isCheckAll}
                              onChange={handleSelectAll}
                            />
                          }
                          label={
                            <Typography
                              sx={{
                                px: 1,
                                fontSize: "0.8rem",
                                fontWeight: "500",
                                color: "#DB8829",
                                "@media (min-width: 1636px)": {
                                  fontSize: "1.4rem",
                                },
                              }}
                            >
                              All Trainers
                            </Typography>
                          }
                        />
                        <FormControl
                          sx={{ minWidth: 150, width: 150 }}
                          size="small"
                        >
                          <Typography
                            sx={{ px: 1, fontSize: '0.8rem', fontWeight: '500', color: '#DB8829', '@media (min-width: 1636px)': { fontSize: '1.4rem' } }}>
                            Select Trainer
                          </Typography>
                          <Select
                            multiple
                            value={selectedTrainers}
                            sx={{
                              borderRadius: 5,
                              backgroundColor: "#FFFFFF",
                            }}
                            renderValue={(selected) => {
                              return map(selected, "value").join(", ");
                            }}
                          >
                            {trainers.map((itemData, index) => (
                              <MenuItem
                                sx={{
                                  color: "#DB8829",
                                  fontSize: "0.8rem",
                                  fontWeight: "500",
                                  "@media (min-width: 1636px)": {
                                    fontSize: "1.2rem",
                                  },
                                }}
                                key={`trainer_${index}`}
                                onClick={() =>
                                  handleSelectMultiple(itemData)
                                }
                              >
                                <Checkbox
                                  checked={
                                    selectedTrainers.filter(
                                      (item) => item.id === itemData.id
                                    ).length > 0
                                  }
                                />
                                <ListItemText primary={itemData.value} />
                              </MenuItem>
                            ))}
                          </Select>
                        </FormControl>
                      </Grid>
                    )}

                  {reportTypeDataId &&
                    reportTypeDataId != "library_report" && (
                      <Grid item>
                        <Box>
                          {trainers &&
                            userInfo &&
                            userInfo.rolesInfo.title.toLowerCase() !== "trainer" &&
                            (reportTypeDataId == "detailed_report" || reportTypeDataId == "batch_wise_usage_report") && (
                              <FormControl
                                sx={{ minWidth: 180, width: 180 }}
                                size="small"
                              >
                                <Typography
                                  sx={{ px: 1, fontSize: '0.8rem', fontWeight: '500', color: '#DB8829', '@media (min-width: 1636px)': { fontSize: '1.4rem' } }}>
                                  Select Trainer
                                </Typography>
                                <Select
                                  sx={{
                                    borderRadius: 20,
                                    borderColor: "#DB8829",
                                    color: "#DB8829",
                                    fontWeight: "500",
                                    "@media (min-width: 1636px)": {
                                      fontSize: "1.4rem",
                                      width: "20ch",
                                      mt: 0.5,
                                    },
                                  }}
                                  value={selectedTrainerId}
                                  onChange={handleSelectSingle}
                                >
                                  {trainers.map((itemData, indexTrainer) => (
                                    <MenuItem
                                      sx={{
                                        color: "#DB8829",
                                        fontSize: "0.8rem",
                                        fontWeight: "500",
                                        "@media (min-width: 1636px)": {
                                          fontSize: "1.2rem",
                                        },
                                      }}
                                      key={`${indexTrainer}_trainer`}
                                      value={itemData.id}
                                    >
                                      {itemData.value}
                                    </MenuItem>
                                  ))}
                                </Select>
                              </FormControl>
                            )}
                          {reportTypeDataId == "batch_wise_usage_report" && (
                            <FormControl
                              sx={{ px: 2, minWidth: 180, width: 180 }}
                              size="small"
                            >
                              <Typography
                                sx={{ px: 1, fontSize: '0.8rem', fontWeight: '500', color: '#DB8829', '@media (min-width: 1636px)': { fontSize: '1.4rem' } }}>
                                Select Class
                              </Typography>
                              <Select
                                multiple
                                value={selectedClassIds}
                                sx={{
                                  borderRadius: 5,
                                  backgroundColor: "#FFFFFF",
                                }}
                                renderValue={(selected) => {
                                  return map(selected, "value").join(", ");
                                }}
                              >
                                {allClasses.map((itemData, indexClass) => {
                                  return (
                                    <MenuItem
                                      sx={{
                                        color: "#DB8829",
                                        fontSize: "0.8rem",
                                        fontWeight: "500",
                                        "@media (min-width: 1636px)": {
                                          fontSize: "1.2rem",
                                        },
                                      }}
                                      key={`${indexClass}_Class`}
                                    >
                                      <Checkbox
                                        checked={
                                          selectedClassIds.filter(
                                            (item) => item.id === itemData.id
                                          ).length > 0
                                        }
                                        onClick={(e) => {
                                          handleClassChange(e, itemData);
                                        }}
                                      />
                                      <ListItemText primary={itemData.value} />
                                    </MenuItem>
                                  );
                                })}
                              </Select>
                            </FormControl>
                          )}
                        </Box>
                      </Grid>
                    )}
                </>
                <Grid item sx={{ px: 1 }}>
                  <FormControl sx={{ minWidth: 150 }} size="small">
                    <Typography
                      sx={{ px: 1, fontSize: '0.8rem', fontWeight: '500', color: '#DB8829', '@media (min-width: 1636px)': { fontSize: '1.4rem' } }}>
                      Select Month
                    </Typography>
                    <Select
                      value={selectedMonthValue}
                      sx={{
                        borderRadius: 20,
                        borderColor: "#DB8829",
                        color: "#DB8829",
                        fontWeight: "500",
                        "@media (min-width: 1636px)": {
                          fontSize: "1.4rem",
                          width: "20ch",
                          mt: 0.5,
                        },
                      }}
                    >
                      {filterByDays.map((itemData, index) => (
                        <MenuItem
                          sx={{
                            color: "#DB8829",
                            fontSize: "0.8rem",
                            fontWeight: "500",
                            "@media (min-width: 1636px)": {
                              fontSize: "1.2rem",
                            },
                          }}
                          key={`${index}_days`}
                          value={itemData.value}
                          onClick={() => handleOnChange(itemData)}
                        >
                          {itemData.label}
                        </MenuItem>
                      ))}
                    </Select>
                  </FormControl>
                </Grid>
              </Grid>
            </Grid>
            <Grid item xs={2} sx={{ pt: 3 }}>
              {!libraryInDetailOn && (
                <Grid
                  container
                  sx={{
                    flexDirection: "row",
                    justifyContent: "space-around",
                    alignItems: "center",
                  }}
                >
                  <Grid>
                    <Button
                      variant="standard"
                      fullWidth
                      sx={{
                        color: "#DB8829",
                        fontSize: "1rem",
                        fontWeight: "700",
                        border: 1,
                        borderColor: "#DB8829",
                        borderRadius: 10,
                       
                        "@media (min-width: 1636px)": { fontSize: "1.4rem" },
                      }}
                      onClick={() => {
                        resetState();
                      }}
                    >
                      Reset
                    </Button>
                  </Grid>
                </Grid>
              )}
            </Grid>
          </Grid>
        </Grid>
        {userInfo && trainerReportData.length > 0 && (
          <Grid container>
            {reportTypeDataId &&
              reportTypeDataId == "content_usage_summary" && (
                <ContentUsageSummary
                  trainerReportData={trainerReportData}
                  fetchTrainer={fetchTrainer}
                />
              )}
          </Grid>
        )}
        {userInfo &&
          reportTypeDataId &&
          reportTypeDataId == "library_report" &&
          selectedTrainers.length > 0 && (
            <LibraryReport
              startDate={startDate}
              endDate={endDate}
              selectedTrainers={selectedTrainers}
              inDetailOn={(flag) => {
                setLibraryInDetailOn(flag);
              }}
            />
          )}
        {userInfo &&
          reportTypeDataId &&
          reportTypeDataId == "detailed_report" &&
          selectedTrainers.length > 0 &&
          trainerDetailData && trainerDetailData.data && (
            <TrainerDetailReport
              courseDetailData={courseDetailData}
              taskDetailData={taskDetailData}
              assiDetailData={assiDetailData}
              evalDetailData={evalDetailData}
            />
          )}
        {userInfo &&
          reportTypeDataId &&
          reportTypeDataId == "batch_wise_usage_report" &&
          selectedTrainers.length > 0 &&
          selectedClassIds.length > 0 &&
          batchWiseTrainerData && batchWiseTrainerData.data && (
            <BatchWiseUsageReport
              batchWiseCourseData={batchWiseCourseData}
              allClasses={allClasses}
            />
          )}

        {trainerReportData.length === 0 ||
          (reportTypeDataId == "library_report" &&
            selectedTrainers.length == 0 && (
              <Placeholder
                primaryText="No report data found"
                secondaryText="No data found!"
                image="assign"
              ></Placeholder>
            ))}
      </Box>

      {isWwDateFilter &&
        <WwDateFilterModal
          press={handleFilterReport}
          visible={isWwDateFilter}
          toggleModal={(flag) => setIsWwDateFilter(flag)}
        />
      }

      <Snackbar
        anchorOrigin={{ vertical, horizontal }}
        autoHideDuration={6000}
        open={open}
        onClose={handleClose}
        message="Please select trainer!"
        key={vertical + horizontal}
      />
    </>
  );
};

const useStyles = makeStyles({
  scrollBar: {
    "&::-webkit-scrollbar": {
      width: "0.6em",
    },
    "&::-webkit-scrollbar-track": {
      backgroundColor: "#ffe600ff",
      "-webkit-box-shadow": "inset 0 0 6px rgba(0,0,0,0.00)",
      borderRadius: 5,
    },
    "&::-webkit-scrollbar-thumb": {
      backgroundColor: "#5f5600ff",
      borderRadius: 5,
    },
  },
});
export default TrainersReport;
